import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "main-components-container" }
const _hoisted_3 = {
  class: "main-component-view component-container",
  style: {"overflow":"auto"}
}
const _hoisted_4 = {
  key: 0,
  class: "component-container"
}

import { computed, inject, ref } from 'vue';
import { onMounted } from 'vue';
import { useStore } from 'vuex';

import { AlertService, getGlobalProps } from '@rednex/gateway_core';
import '@rednex/gateway_core/dayjs';
//### Function imports

//### Service imports
import PropertyService from '@/project/services/property.service';
//--- Service imports

//### Model imports
//--- Model imports

//### Component imports
import NavigationBar from '@/core/navigation-bar/navigation-bar.vue';
import Sidebar from '@/core/sidebar/sidebar.vue';
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

//### Function imports
const alertService = inject<AlertService>('alertService');
const propertyService = inject<PropertyService>('propertyService');

const globalProps = getGlobalProps();
const store = useStore();
//--- Setup

//### Store/Reactive Data
const extendedSearchComponentVisible = computed(() => store.getters.extendedSearchComponentVisible);
const inList = computed(() => store.getters.inList);
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const menuExpanded = computed(() => store.getters.menuExpanded);
const themeMode = computed(() => store.getters.themeMode);
//--- Store/Reactive Data

//### Variables const let
let ctxExtendedSearch;
const info = ref(null);
const visible = ref(false);
//--- Variables const let

//### Component Lifecycle
onMounted(() => {
  refreshTheme();
  retrieveInfo();
  setInterval(() => {
    retrieveInfo();
  }, 5000);
});
//--- Component Lifecycle

//### Functions
function refreshTheme() {
  // themeMode.value === 'dark' ? require('@content/scss/rs-theme/rs-theme-dark.scss') : require('@content/scss/rs-theme/rs-theme.scss');
  require('@content/scss/rs-theme/rs-theme-dark.scss');
}

function retrieveInfo() {
  propertyService
    .get('info')
    .then(res => {
      if (res.data && info.value != res.data) {
        info.value = res.data;
        if (info.value) {
          visible.value = true;
        }
      }
    })
    .catch(error => {
      alertService.showHttpError(globalProps, error);
    });
}
//--- Functions

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(menuExpanded.value ? 'menu-expanded-wrapper' : 'menu-hidden-wrapper')
    }, [
      _createCommentVNode("      <Sidebar></Sidebar>"),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(NavigationBar),
        _createElementVNode("div", _hoisted_3, [
          (isAuthenticated.value && extendedSearchComponentVisible.value && inList.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_unref(ctxExtendedSearch))
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_router_view)
        ])
      ])
    ], 2 /* CLASS */),
    _createCommentVNode(" eslint-disable-next-line "),
    _createVNode(_component_Dialog, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      modal: "",
      header: "Info",
      style: { width: '50vw' },
      breakpoints: { '960px': '75vw', '641px': '90vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(info.value), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"]),
    _createVNode(_component_Toast)
  ]))
}
}

})